import { Injectable } from '@angular/core';
import { Account, AccountCollection, AdminService as CloudAdmin } from '@mitel/cloudlink-sdk/admin';
import { ErrorsHandlerService } from './errors-handler.service';
import { getOdataNext, Odata } from '@mitel/cloudlink-sdk/utils';
import { CloudLinkService } from './cloudlink.service';

@Injectable({providedIn: 'root'})
export class AdminService {
	private readonly api: CloudAdmin;

	constructor(
		cloudlinkService: CloudLinkService,
		private errService: ErrorsHandlerService,
	) {
		this.api = cloudlinkService.adminService;
	}

	public getAccount(accountId: string): Promise<Account> {
		// console.log('Function: getAccount, GET ACCOUNT:');
		return new Promise<Account>(async (resolve, reject) => {
			try {
				let account = await this.api.getAccount({accountId}).then(response => response?.body);
				resolve(account);
			} catch (err) {
				this.errService.handleError(err);
				reject(err);
			}
		});
	}

	public getAllAccounts(odata?: Odata): Promise<Account[]> {
		return new Promise<Account[]>(async (resolve, reject) => {
			let accounts: Account[];
			try {
				// console.log('Function: , odata: ', odata);
				const accountCollection = await this.getAccounts(odata);
				if (accountCollection && accountCollection.count > 0 && accountCollection._embedded && accountCollection._embedded.items) {
					accounts = accountCollection._embedded.items;
					const next = getOdataNext(accountCollection);
					if (next && next.skipToken) {
						next.skipToken = decodeURIComponent(next.skipToken); // Decode the skipToken
						const moreAccounts = await this.getAllAccounts(next);
						if (moreAccounts) {
							accounts = accounts.concat(moreAccounts);
						}
					}
				}
				resolve(accounts);
			} catch (err) {
				this.errService.handleError(err);
				reject(err);
			}
		});
	}

	public getAccounts(odata?: Odata, options?: any): Promise<AccountCollection> {
		if (odata) {
			return this.api.getAccounts({
				expand: odata.expand, skip: odata.skip,
				top: odata.top, skipToken: odata.skipToken, options
			}).then(response => response?.body);
		} else {
			return this.api.getAccounts({ options }).then(response => response?.body);
		}
	}

	public getAccountTags(accountId: string): Promise<any> {
		return this.api.getAccountTags({accountId}).then(response => response?.body);
	}
}
